import { io } from "socket.io-client";
import config from './config'
const {socketUrl} = config

const SOCKET_URL = socketUrl 

const token = localStorage.getItem("jwtToken");

export const socket = io(SOCKET_URL+'?token='+token, {
  transports: ["websocket"],
  autoConnect: false,      
});


export const exChangeSocket = io(SOCKET_URL, {
  transports: ["websocket"],
  autoConnect: false,
});
